<template>
    <div class="elecciones">
        <h2>Elecciones</h2>

        <div v-if="actionsAdminVisible" class="elecciones-actions">
            <v-btn :disabled="isLoading" @click="showCreateElection = true">
                <span v-if="isLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                </span>
                <template v-else> Crear Campaña Electoral</template>
            </v-btn>
        </div>
        <br />

        <span v-if="isLoading" key="loading">
            <i class="fa fa-spinner fa-spin"></i>
        </span>
        <template v-else>
            <div v-if="!elecciones.length" class="no-eleccion">
                No se han creado campañas electorales
            </div>
            <v-data-table
                v-else
                :headers="headers"
                :items="elecciones"
                :items-per-page="5"
                :search="search"
                class="contratos-table"
                multi-sort
                @#click:row="showDetails"
            >
                <template v-slot:[`item.description`]="{ item }">
                    <small>
                        <b>{{ (item.type || '').toUpperCase() }}</b>
                    </small>
                    <br />
                    {{ item.description }}
                    <br />
                    <small>
                        <b> Web Service:</b>
                        {{ item.is_ws_production ? 'Producción' : 'Pruebas' }}
                    </small>
                </template>
                <template v-slot:[`item.emails_enabled`]="{ item }">
                    {{ item.emails_enabled ? 'Si' : 'No' }}
                </template>
                <template v-slot:[`item.duration`]="{ item }">
                    <div>
                        <span
                            class="light-blue--text text--darken-4 font-weight-bold"
                        >
                            Inicio <br />
                        </span>

                        {{ item.start_date }}
                        <br />
                        <span
                            class="light-blue--text text--darken-4 font-weight-bold"
                        >
                            Fin <br />
                        </span>
                        {{ item.end_date }}
                    </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip content-class="tooltip" top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="
                                    item.election_status ===
                                        'election_data_inserted' ||
                                        item.election_status ===
                                            'Vote_&_bc_data_inserted' ||
                                        item.election_status === 'Vote' ||
                                        item.election_status === 'Finished' ||
                                        item.election_status ===
                                            'wait_election_start'
                                "
                                :disabled="downloading"
                                class="mr-1 mb-1"
                                small
                                v-bind="attrs"
                                @click="downLoadCSV(item.id)"
                                v-on="on"
                            >
                                <i class="fas fa-user mr-1"></i>
                                <i class="fas fa-file-download"></i>
                            </v-btn>
                        </template>
                        <span>Descargar contraseñas funcionarios</span>
                    </v-tooltip>
                    <v-tooltip content-class="tooltip" top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="
                                    item.election_status ===
                                        'election_data_inserted' ||
                                        item.election_status ===
                                            'Vote_&_bc_data_inserted' ||
                                        item.election_status === 'Vote' ||
                                        item.election_status === 'Finished' ||
                                        item.election_status ===
                                            'wait_election_start'
                                "
                                :disabled="downloading"
                                class="mr-1 mb-1"
                                small
                                v-bind="attrs"
                                @click="downLoadSubComissionsCSV(item.id)"
                                v-on="on"
                            >
                                <i class="fas fa-users mr-1"></i>
                                <i class="fas fa-file-download"></i>
                            </v-btn>
                        </template>
                        <span>Descargar contraseñas subcomisiones</span>
                    </v-tooltip>

                    <v-btn
                        v-if="item.cron_error && actionsAdminVisible"
                        small
                        @click="retryElection(item.id)"
                    >
                        <i class="fas fa-sync"></i>
                    </v-btn>

                    <v-tooltip content-class="tooltip" top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="
                                    actionsAdminVisible &&
                                        item.election_status === 'Waiting_files'
                                "
                                :disabled="deletingElection"
                                class="mr-1 mb-1"
                                small
                                v-bind="attrs"
                                @click="
                                    $router.push({
                                        name: 'Admin - Eleccion',
                                        params: { eleccionId: item.id },
                                    })
                                "
                                v-on="on"
                            >
                                <span>
                                    <i class="fa fa-file-alt"></i>
                                </span>
                            </v-btn>
                        </template>
                        <span>Cargar archivos csv</span>
                    </v-tooltip>
                    <br />

                    <v-tooltip content-class="tooltip" top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-1 mb-1"
                                small
                                v-bind="attrs"
                                @click="displayInfo(item)"
                                v-on="on"
                            >
                                <i class="far fas fa fa-info"></i>
                            </v-btn>
                        </template>
                        <span>Información de la elección</span>
                    </v-tooltip>

                    <v-tooltip
                        v-if="(item.type || '').toUpperCase() === 'CUEMS'"
                        content-class="tooltip"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-1 mb-1"
                                small
                                v-bind="attrs"
                                @click="editElection(item)"
                                v-on="on"
                            >
                                <i class="fa fas fa-pencil-alt"></i>
                            </v-btn>
                        </template>
                        <span>Editar elección</span>
                    </v-tooltip>

                    <v-tooltip content-class="tooltip" top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-if="actionsAdminVisible"
                                :disabled="deletingElection"
                                class="red white--text"
                                small
                                v-bind="attrs"
                                @click="askForDelteConfirmation(item)"
                                v-on="on"
                            >
                                <span v-if="!deletingElection">
                                    <i class="fa fa-trash"></i>
                                </span>
                                <span v-else>
                                    <i class="fa fa-2x fa-spinner fa-spin"></i>
                                </span>
                            </v-btn>
                        </template>
                        <span>Eliminar elección</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </template>

        <v-dialog
            v-model="showCreateElection"
            max-width="600"
            scrollable
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark>
                    <v-btn dark icon @click="showCreateElection = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Crear Elección</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="showCreateElection = false">
                            Cancelar
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <CrearEleccion
                        v-if="showCreateElection"
                        @hide="hideModal"
                    ></CrearEleccion>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showEditElection"
            max-width="600"
            scrollable
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark>
                    <v-btn dark icon @click="showEditElection = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Editar Elección</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="showEditElection = false">
                            Cancelar
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <EditarEleccion
                        v-if="showEditElection"
                        :election="electionSelected"
                        @hide="hideModal"
                    ></EditarEleccion>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDeleteConfirmation" max-width="330">
            <v-card>
                <v-card-title class="headline">
                    La elección será borrada
                </v-card-title>
                <v-card-text>
                    Si continuas la elección con descripción '{{
                        electionToDelete.description
                    }}' del tipo '{{ electionToDelete.type }}' y toda la
                    información relacionada a ella será borrada en la base de
                    datos.
                    <br />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="!deletingElection"
                        text
                        @click="showDeleteConfirmation = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="deletingElection"
                        color="red darken-1"
                        text
                        @click="deleteElection"
                    >
                        <template v-if="!deletingElection">
                            Sí, eliminar
                        </template>
                        <span v-else>
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showElectionDetails"
            max-width="600"
            transition="dialog-top-transition"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-container>
                            <v-row>
                                <v-col class="text-left">
                                    {{ electionSelected.id }}
                                    {{ electionSelected.description }}
                                </v-col>
                                <v-col class="text-left" cols="12">
                                    <b>
                                        <small>
                                            {{ electionSelected.type }}
                                        </small>
                                    </b>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-toolbar>
                    <v-card-text class="py-5">
                        <v-row>
                            <v-col class="text-left">
                                <span>
                                    <b>Inicio:</b>
                                    {{ electionSelected.start_date }}
                                </span>
                            </v-col>
                            <v-col class="text-left">
                                <span>
                                    <b>Fin:</b>
                                    {{ electionSelected.start_date }}
                                </span>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="text-left">
                                <v-btn
                                    v-if="electionSelected.users_file"
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.users_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i> &nbsp;
                                    {{
                                        (
                                            electionSelected.type || ''
                                        ).toUpperCase()
                                    }}
                                </v-btn>
                                <v-btn
                                    v-if="electionSelected.ures_file"
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.ures_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i> &nbsp;URES
                                </v-btn>
                                <v-btn
                                    v-if="
                                        electionSelected.funcionarios_mesa_file
                                    "
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.funcionarios_mesa_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i>
                                    &nbsp;Funcionarios Mesa
                                </v-btn>
                                <v-btn
                                    v-if="electionSelected.int_planilla_file"
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.int_planilla_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i> &nbsp;Int
                                    planilla
                                </v-btn>
                                <v-btn
                                    v-if="
                                        electionSelected.listado_app_voto_file
                                    "
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.listado_app_voto_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i> &nbsp;Listado
                                    App Voto
                                </v-btn>

                                <v-btn
                                    v-if="electionSelected.ocg_file"
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.ocg_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i> &nbsp;OCG
                                </v-btn>
                                <v-btn
                                    v-if="electionSelected.subcomisiones_file"
                                    class="mr-1 mb-1"
                                    @click="
                                        downloadFile(
                                            electionSelected.id,
                                            electionSelected.subcomisiones_file
                                        )
                                    "
                                >
                                    <i class="fa fa-download"></i>
                                    &nbsp;Subcomisiones
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions
                        class="
								justify-end"
                    >
                        <v-btn text @click="dialog.value = false"
                            >Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import CrearEleccion from '@components/admin/Elecciones/CrearEleccion';
import EditarEleccion from '@components/admin/Elecciones/EditarEleccion';
import { mapGetters } from 'vuex';
import api from '@/api';
import { ADMIN_TYPE } from '@/helpers/roleTypes';
import _ from 'lodash';

export default {
    components: {
        CrearEleccion,
        EditarEleccion,
    },
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
        mode() {
            return _.get(this, '$store.getters.user.mode');
        },
        headers() {
            return [
                { text: 'Id', value: 'id', sortable: true },
                { text: 'Descripción', value: 'description', sortable: true },
                { text: 'Duración', value: 'duration', sortable: true },
                { text: 'Enviar correos', value: 'emails_enabled' },
                {
                    text: 'Election status',
                    value: 'election_status',
                    sortable: true,
                },
                ...(this.actionsAdminVisible
                    ? [
                          {
                              text: 'Cron status',
                              value: 'cron_status',
                              sortable: true,
                          },
                          {
                              text: 'Cron Error',
                              value: 'cron_error',
                              sortable: true,
                          },
                      ]
                    : []),
                { text: 'Acciones', value: 'actions', sortable: true },
            ];
        },
        actionsAdminVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
    },
    data() {
        return {
            showCreateElection: false,
            showEditElection: false,
            showDeleteConfirmation: false,
            showElectionDetails: false,
            electionToDelete: {},
            isLoading: true,
            isLoadingElection: false,
            downloading: false,
            deletingElection: false,
            retryingElection: false,
            askDelete: false,
            changinStatus: false,
            search: '',
            electionSelected: {},
        };
    },
    methods: {
        displayInfo(item) {
            this.electionSelected = item;
            this.showElectionDetails = true;
        },
        showDetails(election) {
            console.log(election);
        },
        hideModal() {
            this.showCreateElection = false;
            this.showEditElection = false;
            this.getElections();
            this.electionSelected = {};
        },
        startVote(id) {
            if (this.changinStatus) {
                return;
            }
            this.changinStatus = true;
            this.$store
                .dispatch('elecciones/startVoting', id)
                .then(() => {
                    this.$store.dispatch('successMessage', `Status changed`);
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.changinStatus = false));
        },
        getState(id) {
            if (this.changinStatus) {
                return;
            }
            this.changinStatus = true;
            this.$store
                .dispatch('elecciones/getState', id)
                .then(res => {
                    this.$store.dispatch(
                        'successMessage',
                        `Election id ${id} - state ${res.getStage}`
                    );
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.changinStatus = false));
        },
        startElection() {
            this.isLoading = true;
            this.$store
                .dispatch('elecciones/startElection')
                .then(electionInserted => {
                    if (electionInserted) {
                        this.getElections();
                    }
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.isLoading = false));
        },
        getElections() {
            this.isLoading = true;
            this.$store
                .dispatch('elecciones/getElecciones')
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        deleteElections() {
            this.isLoading = true;
            this.$store
                .dispatch('elecciones/deleteElecciones')
                .catch(error => {
                    console.error(error);
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.askDelete = false;
                    this.getElections();
                });
        },
        editElection(item) {
            this.electionSelected = item;
            this.showEditElection = true;
        },
        askForDelteConfirmation(item) {
            this.showDeleteConfirmation = true;
            this.electionToDelete = item;
        },
        deleteElection() {
            if (this.deletingElection) {
                return;
            }
            this.deletingElection = true;
            this.$store
                .dispatch('elecciones/deleteEleccion', this.electionToDelete.id)
                .then(() => {
                    this.$store.dispatch(
                        'successMessage',
                        `Elección ${this.electionToDelete.id} borrada`
                    );
                    this.showDeleteConfirmation = false;
                    this.electionToDelete = {};
                    this.getElections();
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.deletingElection = false));
        },
        retryElection(id) {
            if (this.retryingElection) {
                return;
            }
            this.retryingElection = true;
            this.$store
                .dispatch('elecciones/retryElection', id)
                .then(() => {
                    this.$store.dispatch('successMessage', 'Retrying');
                    this.showDeleteConfirmation = false;
                    this.electionToDelete = {};
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.retryingElection = false));
        },
        downLoadCSV(electionId) {
            const token = this.$store.getters.token;

            const url = `${api.defaults.baseURL}/passwords/${electionId}?jwt=${token}`;

            window.open(url, '_blank');
        },
        downLoadSubComissionsCSV(electionId) {
            const token = this.$store.getters.token;

            const url = `${api.defaults.baseURL}/passwords-subcomissions/${electionId}?jwt=${token}`;

            window.open(url, '_blank');
        },
        downloadFile(electionId, file) {
            const token = this.$store.getters.token;
            file = file.split('/').reverse()[0];

            const baseURL =
                process.env.NODE_ENV === 'development'
                    ? 'http://192.168.0.113:3000/management'
                    : 'https://appelectoral.udg.mx/api/management';

            const url =
                baseURL +
                `/configuration-file/${electionId}/${file}?jwt=${token}`;
            window.open(url, '_blank');
        },
    },
    created() {
        this.getElections();
    },
};
</script>

<style scoped lang="scss">
.elecciones {
    width: 100%;
    overflow-x: auto;
    padding: 20px 10px;

    &-actions {
        display: flex;
        justify-content: flex-end;

        button {
            padding: 5px;
        }
    }
}

.btn {
    padding: 5px;
    margin: 3px;
}

.tooltip {
    padding: 5px;
}
</style>
